/**
 * mutate-router (US-AI.F2-0231 · @UC9400) — LỐI RA THẬT cho ý định XOÁ/SỬA. Hàm THUẦN (không LLM/DB).
 *
 * VÌ SAO TỒN TẠI (bug THẬT nhóm G5-risky):
 *  - @SEC-RISK-05 / @AI-RISK-02 / @AI-RSK-03 — trước đây MỌI câu xoá/sửa ("Xoá đợt thu tháng 7",
 *    "Xoá hết đi") đều sinh proposal kind='mutate' + thẻ "Nhấn xác nhận", nhưng confirm LUÔN bị huỷ
 *    ⇒ user bấm Xác nhận rồi nhận câu vô nghĩa và TIN LÀ ĐÃ XOÁ. Ngõ cụt + nói dối.
 *  - @AI-RISK-03 / @AI-RSK-02 — nút "Sửa" ghép chuỗi "Sửa đề xuất..." gửi lại như câu chat ⇒ lại khớp
 *    MUTATE ⇒ lại bị từ chối = VÒNG LẶP CHẾT. Sửa phải là RE-PROPOSE CÓ CẤU TRÚC (patch field), KHÔNG
 *    ghép câu tự nhiên.
 *
 * NGUYÊN TẮC: AI KHÔNG tự xoá/sửa. Câu xoá/sửa XÁC ĐỊNH được đối tượng ⇒ ĐƯA NGƯỜI DÙNG TỚI MÀN GUI
 * THẬT (deep-link) nơi họ tự làm. KHÔNG xác định được ⇒ HỎI LẠI (clarify), TUYỆT ĐỐI không hiện thẻ
 * xác nhận huỷ diệt mơ hồ.
 *
 * 🔴 US-AI-0310-S07 — 3 route THÔ ở đây (`/collections`, `/expenses`, `/transactions`) là link CHẾT:
 * `app_router.dart` KHÔNG có màn danh sách trần nào (chỉ `/collections/:collectionId/...`,
 * `/expenses/:expenseId/...`, `/ledger/:entryId`). Guard A (`deep-link-usage.spec.ts`) cũ chỉ quét
 * `deepLink:` nên bỏ sót key `route:` này — đúng `guard-canh-nham-cho-pattern` lần thứ N. AI chưa chốt
 * được id cụ thể ⇒ dẫn về `/funds` (FUND_LIST — không tham số, LUÔN sống; mirror turn-router
 * buildRedirect). `messageVi` vẫn nói rõ "màn Đợt thu / Chi tiêu / Giao dịch" nên ngữ cảnh không mất.
 */
import { ROUTE_CATALOG } from "./orchestration/route-catalog.js";

/** Route GUI thật khi AI chưa chốt được id — danh sách quỹ (không tham số ⇒ luôn sống). */
const MANAGE_ROUTE = ROUTE_CATALOG.mobile.FUND_LIST!.pathTemplate;

/** Đối tượng bị nhắm bởi câu xoá/sửa (chỉ những gì có màn GUI thật). */
export type MutateTarget = "collection" | "expense" | "transaction";

/** Kết quả định tuyến ý định mutate. */
export type MutateRoute =
  | {
      /** Có màn GUI thật để người dùng tự làm — điều hướng, KHÔNG tạo proposal. */
      readonly kind: "deep_link";
      readonly target: MutateTarget;
      /** Route đích trong app (danh sách để user chọn đúng bản ghi — id do GUI chọn, AI KHÔNG đoán id). */
      readonly route: string;
      readonly messageVi: string;
    }
  | {
      /** Không xác định được đối tượng ⇒ HỎI LẠI (không thẻ huỷ diệt mơ hồ — @AI-RSK-03). */
      readonly kind: "clarify";
      readonly messageVi: string;
    };

/** Từ khoá đối tượng → màn GUI thật (đúng route app). */
const TARGET_RULES: ReadonlyArray<{
  readonly re: RegExp;
  readonly target: MutateTarget;
  readonly route: string;
  readonly messageVi: string;
}> = [
  {
    re: /(đợt thu|dot thu|khoản thu|khoan thu|collection)/iu,
    target: "collection",
    route: MANAGE_ROUTE,
    messageVi:
      "Mình không tự xoá/sửa đợt thu. Bạn mở màn Đợt thu, chọn đúng đợt rồi sửa/xoá ở đó nhé — mình đưa bạn tới ngay.",
  },
  {
    re: /(khoản chi|khoan chi|chi tiêu|chi tieu|expense)/iu,
    target: "expense",
    route: MANAGE_ROUTE,
    messageVi:
      "Mình không tự xoá/sửa khoản chi. Bạn mở màn Chi tiêu, chọn đúng khoản rồi sửa/xoá ở đó nhé — mình đưa bạn tới ngay.",
  },
  {
    re: /(giao dịch|giao dich|bút toán|but toan|transaction)/iu,
    target: "transaction",
    route: MANAGE_ROUTE,
    messageVi:
      "Sổ quỹ chỉ GHI THÊM: khoản đã ghi thì không xoá được — muốn sửa thì ghi thêm một dòng điều chỉnh. Bạn mở màn Giao dịch để thao tác nhé.",
  },
];

/** Câu xoá "diện rộng" ("xoá hết", "xoá tất cả") — nguy hiểm nhất, LUÔN hỏi lại. @AI-RSK-03 */
const BULK_DESTRUCTIVE = /(hết|het|tất cả|tat ca|toàn bộ|toan bo|sạch|sach)/iu;

/**
 * 🔴 US-AI-0476-S02 (@UC9748) — PHƠI phép đo "xoá diện rộng" ra ngoài, KHÔNG chép regex.
 *
 * `turn-router` cần biết *"câu này có phải xoá-diện-rộng không"* để hỏi lại thay vì đẩy người dùng
 * vào màn quản lý. Nó **không** được khai một `BULK_DESTRUCTIVE` thứ hai: hai bản chép của một luật
 * an toàn sớm muộn lệch nhau, và bản lệch sẽ là bản người dùng gặp (`CLAUDE.md` §3.8).
 *
 * ⚠️ Chỉ phơi PHÉP ĐO, không phơi regex — `routeMutateIntent` bên dưới gọi CHÍNH hàm này, nên không
 * có đường nào để hai bên trả lời khác nhau.
 */
export function isBulkDestructiveMutate(message: string): boolean {
  return BULK_DESTRUCTIVE.test((message ?? "").trim());
}

/**
 * Định tuyến câu mutate → deep-link GUI (đối tượng RÕ) hoặc clarify (mơ hồ / diện rộng).
 * KHÔNG BAO GIỜ trả "proposal xác nhận" — AI không xoá/sửa hộ (@SEC-RISK-05 @AI-RISK-02).
 */
export function routeMutateIntent(message: string): MutateRoute {
  const text = (message ?? "").trim();

  // @AI-RSK-03 — "Xoá hết đi": KHÔNG đoán "hết" là gì. Hỏi lại, không thẻ huỷ diệt.
  if (isBulkDestructiveMutate(text)) {
    return {
      kind: "clarify",
      messageVi:
        "Bạn muốn xoá cụ thể cái gì? (một đợt thu, một khoản chi, hay một giao dịch?) Mình không xoá hàng loạt — và mình cũng không tự xoá hộ bạn.",
    };
  }

  for (const rule of TARGET_RULES) {
    if (rule.re.test(text)) {
      return { kind: "deep_link", target: rule.target, route: rule.route, messageVi: rule.messageVi };
    }
  }

  return {
    kind: "clarify",
    messageVi:
      "Bạn muốn sửa/xoá cái gì ạ? Cho mình biết là đợt thu, khoản chi hay giao dịch nhé — mình sẽ đưa bạn tới đúng màn để tự thao tác.",
  };
}

/**
 * @AI-RISK-03 @AI-RSK-02 — RE-PROPOSE CÓ CẤU TRÚC: nút "Sửa" trên thẻ đề xuất KHÔNG ghép câu tự nhiên
 * gửi lại chat (câu ghép lại khớp MUTATE ⇒ bị từ chối ⇒ vòng lặp chết). Client gửi PATCH field trực
 * tiếp: chỉ tên thành viên và/hoặc số tiền — server dựng proposal mới từ patch (không parse lại NLP).
 */
export interface AiReproposePatch {
  /** Tên thành viên MỚI (vẫn phải resolve → memberId THẬT trước khi ghi — @SEC-WRONG-01). */
  readonly memberName?: string | null;
  /** Số tiền MỚI (minor VND, BigInt — no-float). */
  readonly amountMinor?: bigint | null;
}

/** Patch rỗng = không sửa gì ⇒ caller từ chối (tránh tạo proposal trùng vô nghĩa). */
export function isEmptyReproposePatch(patch: AiReproposePatch): boolean {
  return (
    (patch.memberName === undefined || patch.memberName === null) &&
    (patch.amountMinor === undefined || patch.amountMinor === null)
  );
}
